module.exports = __webpack_public_path__ + "img/SOLCASINO.3b0c237e.svg";